module.exports = __webpack_public_path__ + "files/4ec4ebbebbc95f587012dcbfab613686.png";